import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { asRem } from 'lib/css';
import { Text16Bold, Text14Regular, Label12Regular } from 'style/typography';

const TooltipWrapper = styled.div`
  background: var(--color-secondary-bg);
  border: 1px solid var(--color-border-2);
  border-radius: ${asRem(16)};
  padding: ${asRem(24)};
  max-width: ${asRem(380)};
  min-width: ${asRem(280)};
  color: var(--color-text-1);
  box-shadow: 0 ${asRem(8)} ${asRem(32)} rgba(0, 0, 0, 0.4);

  .tooltip-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: ${asRem(8)};

    .step-counter {
      color: var(--color-text-2);
      flex-shrink: 0;
      margin-left: ${asRem(12)};
    }
  }

  .tooltip-body {
    color: var(--color-text-2);
    margin-bottom: ${asRem(20)};
  }

  .tooltip-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .btn-skip {
      background: transparent;
      border: none;
      color: var(--color-text-2);
      cursor: pointer;
      padding: ${asRem(8)} ${asRem(4)};
      font-size: var(--text-md-fontSize);

      &:hover {
        color: var(--color-text-1);
      }
    }

    .footer-nav {
      display: flex;
      gap: ${asRem(8)};
    }

    .btn-back {
      background: transparent;
      border: 1px solid var(--color-border-2);
      color: var(--color-text-1);
      padding: ${asRem(8)} ${asRem(16)};
      border-radius: ${asRem(40)};
      cursor: pointer;
      font-size: var(--text-md-fontSize);

      &:hover {
        border-color: var(--color-button-primary-bg);
      }
    }

    .btn-next {
      background: var(--color-button-primary-bg);
      color: var(--color-text-rev);
      border: none;
      padding: ${asRem(8)} ${asRem(16)};
      border-radius: ${asRem(40)};
      cursor: pointer;
      font-weight: var(--bold-fontWeight);
      font-size: var(--text-md-fontSize);
    }
  }
`;

export function TourTooltip({
  step,
  stepIndex,
  totalSteps,
  isLastStep,
  onNext,
  onPrev,
  onSkip,
}) {
  return (
    <TooltipWrapper>
      <div className="tooltip-header">
        {step.title && <Text16Bold as="h4">{step.title}</Text16Bold>}
        <Label12Regular className="step-counter">
          {`${stepIndex + 1} / ${totalSteps}`}
        </Label12Regular>
      </div>
      <div className="tooltip-body">
        <Text14Regular>{step.content}</Text14Regular>
      </div>
      <div className="tooltip-footer">
        {!isLastStep ? (
          <button type="button" className="btn-skip" onClick={onSkip}>
            Skip Tour
          </button>
        ) : <div />}
        <div className="footer-nav">
          {stepIndex > 0 && (
            <button type="button" className="btn-back" onClick={onPrev}>
              Back
            </button>
          )}
          <button type="button" className="btn-next" onClick={onNext}>
            {isLastStep ? 'Finish' : 'Next'}
          </button>
        </div>
      </div>
    </TooltipWrapper>
  );
}

TourTooltip.propTypes = {
  step: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
  }).isRequired,
  stepIndex: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
};
